import { spiritoryWebApi } from '@/lib/axios/SpiritoryWebApi/spiritoryWebApi';
import { SpiritoryWebEndpoints } from '@/types/api/api-v2';
import { TastingCardData } from '@/utilites/tasting-event';

export default async function getPaginatedTastings(
  locale: string,
  scope: 'upcoming' | 'past',
  page: number,
  pageSize: number
) {
  const {
    data: {
      data: { tastings, meta },
    },
  } = await spiritoryWebApi.get('/tastings/all' as SpiritoryWebEndpoints, {
    params: { locale, scope, page, pageSize },
  });
  return { data: tastings as TastingCardData[], meta };
}
